import React, { createContext, useState, useEffect, useContext } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => {
        const saved = localStorage.getItem('theme');
        return saved || 'dark';
    });

    const [background, setBackground] = useState(() => {
        const saved = localStorage.getItem('background');
        return saved || 'modern_logistic';
    });

    useEffect(() => {
        localStorage.setItem('theme', theme);
        document.documentElement.setAttribute('data-theme', theme);
        document.body.className = `theme-${theme}`;
    }, [theme]);

    const backgroundStyles = {
        // Image-based Fallbacks (Existing)
        'modern_logistic': "url('/backgrounds/modern_logistic.png')",
        'abstract_blue': "url('/backgrounds/abstract_blue.png')",
        'nature_minimal': "url('/backgrounds/nature_minimal.png')",

        // New Color Palette
        'solid_dark': '#0f172a',
        'solid_navy': '#1e293b',
        'gradient_sunset': 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
        'gradient_forest': 'linear-gradient(135deg, #064e3b 0%, #022c22 100%)',
        'gradient_royal': 'linear-gradient(135deg, #1e3a8a 0%, #1e1b4b 100%)',
        'soft_slate': '#f8fafc',
        'warm_sepia_bg': '#fdf6e3'
    };

    useEffect(() => {
        localStorage.setItem('background', background);
        const style = backgroundStyles[background] || `url('/backgrounds/${background}.png')`;
        document.documentElement.style.setProperty('--bg-image', style.startsWith('url') || style.startsWith('linear') ? style : 'none');
        if (!style.startsWith('url') && !style.startsWith('linear')) {
            document.body.style.backgroundColor = style;
            document.documentElement.style.setProperty('--bg-image', 'none');
        } else {
            document.body.style.backgroundColor = 'transparent';
        }
    }, [background]);

    const toggleTheme = (newTheme) => {
        setTheme(newTheme);
    };

    const changeBackground = (newBg) => {
        setBackground(newBg);
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme, background, changeBackground }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
